import React, { useCallback } from "react";
import { Flex } from "rebass";
import { toastr } from "react-redux-toastr";

import { ConnectPlaceholder } from "../components/ConnectPlaceholder";
import { GoogleDriveSVG } from "../../svg/GoogleDriveSVG";

import { getGapi } from "../../../../api/googleDrive";

// https://firebase.google.com/docs/reference/js/firebase.auth.Auth#sign-inwith-popup
// this list of errors user does not see.
const errorCodes = [
  "popup_closed_by_user",
];

interface SignInError {
  error: string;
}

export const Connect: React.FC = () => {
  const openSignInPopup = useCallback(() => {
    const gapi = getGapi();

    gapi.auth2.getAuthInstance().signIn({})
      .catch(({ error }: SignInError) => {
        if (!errorCodes.includes(error)) {
          toastr.error("Sign In to Google Drive", error);
        }
      });
  }, []);

  return (
    <Flex
      height="100%"
      justifyContent="center"
      alignItems="center"
    >
      <ConnectPlaceholder
        providerName="Google Drive"
        icon={GoogleDriveSVG}
        onClick={openSignInPopup}
      />
    </Flex>
  );
};
